import "./AffiliateContent.scss";
import { useState } from "react";
import { LogRegLogo } from "../util/LogRegLogo";
import PartnerForm from "./PartnerForm";
import PartnerFormSuccess from "./PartnerFormSuccess";

export default function AffiliateContentForm() {
  const [submitted, setSubmitted] = useState(false);

  return <main className={"affiliate-content"}>
    {!submitted && <>
      <section className={"one"}>
        <div className="content">
          <div className={"form-desc"}>
            <div className={"logo-container"}><LogRegLogo/></div>
            <h2>Partnering with MustHaveMenus</h2>
            <p>The first step in this process is to submit an Affiliate/Partner Request. Our team will review your application and contact you within 2-3 business days via email if we are interested.</p>
            <p>If a partnership between MustHaveMenus and your business sounds like a good fit, we will provide you with our Terms of Service and instructions regarding next steps!</p>
            <p><b>What you get when you partner with MustHaveMenus</b></p>
            <ul>
              <li>&#8226;&nbsp;&nbsp;Access to a partner portal to track all your referred clients</li>
              <li>&#8226;&nbsp;&nbsp;<b>Earn 10% commission on all purchases your clients make</b></li>
              <li>&#8226;&nbsp;&nbsp;Partner spotlight in emails and marketing</li>
              <li>&#8226;&nbsp;&nbsp;Email support with our world-class service team</li>
            </ul>
          </div>
        </div>
      </section>
      <section className={"two form-container"}>
        <p>Please provide us with the following information:</p>
        <PartnerForm setSubmitted={setSubmitted} formWidth={670}/>
      </section>
    </>}
    {submitted &&
    <section>
      <PartnerFormSuccess/>
    </section>}
  </main>
}
